import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/common/enums/api-status';
import { AppConsts } from '@application/common/constants/app-consts';
import { UpdateDocumentationAsync, addAttachmentByDocumentationIdAsync, createDocumentationAsync, deleteDocumentationDocumentAsync, deleteDocumentationByIdAsync, getAllAttachmentsByDocumentationIdAsync, getAllDocumentationAsync, getDocumentationByIdAsync, getDocumentationDocumentByIdAsync } from './documentationThunk';
const documentationRequest = {
    pageNumber: AppConsts.GRID_DEFAULT_PAGE_NUMBER,
    pageSize: AppConsts.GRID_DEFAULT_PAGE_SIZE,
};
const initialState = {
    status: APIStatus.IDLE,
    documentationsRequest: documentationRequest
};
export const documentationSlice = createSlice({
    name: 'documentation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllDocumentationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllDocumentationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.documentations = action.payload;
        })
            .addCase(getAllDocumentationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createDocumentationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createDocumentationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdDocumentation = action.payload;
        })
            .addCase(createDocumentationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDocumentationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDocumentationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.documentation = action.payload;
            state.unchangedDocumentation = action.payload;
        })
            .addCase(getDocumentationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(UpdateDocumentationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(UpdateDocumentationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.updatedDocumentation = action.payload;
        })
            .addCase(UpdateDocumentationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteDocumentationByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteDocumentationByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteDocumentationByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(addAttachmentByDocumentationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addAttachmentByDocumentationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.createdDocument = action.payload;
        })
            .addCase(addAttachmentByDocumentationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getAllAttachmentsByDocumentationIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllAttachmentsByDocumentationIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.documentationDocuments = action.payload;
        })
            .addCase(getAllAttachmentsByDocumentationIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteDocumentationDocumentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteDocumentationDocumentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteDocumentationDocumentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getDocumentationDocumentByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getDocumentationDocumentByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.documentationDocument = action.payload;
        })
            .addCase(getDocumentationDocumentByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default documentationSlice.reducer;
